var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9169 9.66591H10.2586L10.0252 9.44091C10.546 8.83589 10.9266 8.12322 11.1398 7.35392C11.3531 6.58463 11.3936 5.77771 11.2586 4.99091C10.8669 2.67425 8.93356 0.824247 6.60022 0.540913C5.7799 0.437135 4.94671 0.52239 4.16441 0.790154C3.38211 1.05792 2.67143 1.5011 2.08675 2.08577C1.50207 2.67045 1.0589 3.38113 0.791131 4.16343C0.523366 4.94574 0.438111 5.77893 0.54189 6.59925C0.825223 8.93258 2.67522 10.8659 4.99189 11.2576C5.77868 11.3926 6.5856 11.3521 7.3549 11.1389C8.1242 10.9257 8.83686 10.545 9.44189 10.0242L9.66689 10.2576V10.9159L13.2086 14.4576C13.5502 14.7992 14.1086 14.7992 14.4502 14.4576C14.7919 14.1159 14.7919 13.5576 14.4502 13.2159L10.9169 9.66591ZM5.91689 9.66591C3.84189 9.66591 2.16689 7.99091 2.16689 5.91591C2.16689 3.84091 3.84189 2.16591 5.91689 2.16591C7.99189 2.16591 9.66689 3.84091 9.66689 5.91591C9.66689 7.99091 7.99189 9.66591 5.91689 9.66591Z",
    fill: "#5D5F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.daa51f5abe96214312d7c7be35d8fc74.svg";
export { ForwardRef as ReactComponent };